module.exports = __webpack_public_path__ + "img/terminal.74eefbec.svg";